<template>
  <div class="cfo-tool-panel">
    <component :is="toolComponent" v-if="toolComponent" :key="toolId" />
    <div v-else-if="loading" class="empty-state">
      <i class="el-icon-loading"></i>
      <span>工具加载中...</span>
    </div>
    <div v-else class="empty-state">
      <div class="empty-title">未找到工具页面：{{ toolId }}</div>
      <div v-if="loadError" class="empty-error">错误信息：{{ loadError }}</div>
      <div class="empty-tip">请确认工具ID是否在 toolRegistry.js 中注册，或查看控制台获取详细报错堆栈</div>
    </div>
  </div>
</template>

<script>
import { CFO_TOOL_REGISTRY } from './toolRegistry'
// 直接同步引入核心工具,作为动态 import 失败时的兜底,保证页面不空白
import ToolFpaPlStatement from './ToolFpaPlStatement.vue'
import ToolFpaGmForecast from './ToolFpaGmForecast.vue'
import ToolFpaWhatIf from './ToolFpaWhatIf.vue'

const FALLBACK_COMPONENTS = {
  'tool-fpa-1': ToolFpaPlStatement,
  'tool-fpa-2': ToolFpaGmForecast,
  'tool-fpa-3': ToolFpaWhatIf
}

export default {
  name: 'CfoToolPanel',
  props: {
    toolId: { type: String, required: true }
  },
  data() {
    return {
      toolComponent: null,
      loadError: '',
      loading: false
    }
  },
  watch: {
    toolId: {
      immediate: true,
      handler(id) {
        this.loadTool(id)
      }
    }
  },
  methods: {
    async loadTool(id) {
      this.toolComponent = null
      this.loadError = ''
      this.loading = true
      try {
        const entry = CFO_TOOL_REGISTRY[id]
        if (!entry) {
          // 没注册的话先看 fallback
          if (FALLBACK_COMPONENTS[id]) {
            this.toolComponent = FALLBACK_COMPONENTS[id]
          }
          return
        }
        try {
          const mod = await entry.component()
          this.toolComponent = mod.default || mod
        } catch (dynamicErr) {
          // 动态 import 失败,使用同步 fallback
          console.warn(`[CfoToolPanel] 动态加载工具 ${id} 失败,切换同步兜底:`, dynamicErr)
          if (FALLBACK_COMPONENTS[id]) {
            this.toolComponent = FALLBACK_COMPONENTS[id]
          } else {
            throw dynamicErr
          }
        }
      } catch (e) {
        console.error(`[CfoToolPanel] 加载工具 ${id} 失败:`, e)
        this.loadError = (e && (e.message || e.toString())) || '未知错误'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cfo-tool-panel {
  height: 100%;
  min-height: 0;
  overflow: auto;
}
.empty-state {
  padding: 60px 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  .el-icon-loading {
    font-size: 20px;
    color: #3b82f6;
  }
  .empty-title {
    font-size: 15px;
    color: #64748b;
    font-weight: 500;
  }
  .empty-error {
    padding: 10px 14px;
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #b91c1c;
    border-radius: 6px;
    font-size: 12px;
    max-width: 560px;
    word-break: break-all;
    text-align: left;
  }
  .empty-tip {
    font-size: 12px;
    color: #94a3b8;
  }
}
</style>
